<dsp-content-card [header]="false">
  <atlas-card dsp-content fullWidth="false" elevation="raised">
    <atlas-card-header [ngClass]="(isMobile$ | async) ? 'dsp-filters-row' : 'dsp-filters-row'">
      <atlas-tab-group dsp-content fullWidth="false"
        [ngClass]="(isMobile$ | async) ? 'dsp-filters-row' : 'dsp-filters-row'"
        [selectedIndex]="selectedTabIndex$ | async" (selectedIndexChange)="changeTab($event)">
        <atlas-tab *ngFor="let tab of tabs$ | async as tabs">
          <ng-template atlas-tab-label>
            <span [id]="tab.path + '-tab-label'">{{ tab.name }}</span>
          </ng-template>
        </atlas-tab>
      </atlas-tab-group>
    </atlas-card-header>
    <atlas-card-content dsp-content class="dsp-content-padding" [style.min-height.vh]="50">
      <router-outlet></router-outlet>
    </atlas-card-content>
  </atlas-card>
</dsp-content-card>

<!-- [ngClass]="(isMobile$ | async) ? 'dsp-mobile-header-tabs' : 'dsp-header-tabs'" -->